module.exports = __webpack_public_path__ + "static/boi-d2e4f4684fbf8f38b18f3ce2e10a20f0.jpg";